import type { Block } from '../lib/types';

/**
 * Renders a lesson body.
 *
 * Every block type carries plain text — no HTML is accepted by the API or rendered here,
 * so there is no sanitiser and no dangerouslySetInnerHTML anywhere in this file. That is
 * a deliberate constraint, and the eight types have covered the whole corpus so far.
 */
export function Blocks({ blocks }: { blocks: Block[] }) {
  return (
    <div className="vu-prose">
      {blocks.map((block, i) => (
        <BlockView key={i} block={block} />
      ))}
    </div>
  );
}

function BlockView({ block }: { block: Block }) {
  switch (block.t) {
    case 'p':
      return <p>{block.x}</p>;

    case 'h':
      return <h3>{block.x}</h3>;

    case 'ul':
      return (
        <ul>
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      );

    case 'ol':
      return (
        <ol>
          {block.items.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ol>
      );

    case 'note':
      return (
        <aside className={`vu-note vu-note-${block.tone}`}>
          <div className="vu-note-title">{block.title}</div>
          <div>{block.x}</div>
        </aside>
      );

    case 'do':
      return (
        <div className="vu-dodont">
          <div className="vu-do">
            <h4 style={{ color: 'var(--success)' }}>Do</h4>
            <ul>
              {block.dos.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
          <div className="vu-dont">
            <h4 style={{ color: 'var(--danger)' }}>Don't</h4>
            <ul>
              {block.donts.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      );

    case 'stat':
      return (
        <div className="vu-stat">
          {block.items.map((item, i) => (
            <div className="vu-stat-row" key={i}>
              <span className="vu-stat-k">{item.k}</span>
              <span className="vu-stat-v">{item.v}</span>
            </div>
          ))}
        </div>
      );

    case 'quote':
      return (
        <blockquote className="vu-quote">
          {block.x}
          <cite className="vu-quote-who">— {block.who}</cite>
        </blockquote>
      );
  }
}
